<template>
    <div class="container">
        <div class="marketplace-nav">
            <h3
                :class="isOnListing ? 'active' : ''"
                @click="$emit('change-to-listing')"
            >
                P2P Selling
            </h3>
            <h3
                :class="!isOnListing ? 'active' : ''"
                @click="$emit('change-to-leaderboard')"
            >
                Leaderboard
            </h3>
        </div>
        <div>
            <v-btn
                v-show="isOnListing"
                @click="onClick()"
                class="ma-2"
                color="#ffd876"
                dark
            >
                <div v-if="!showAddListing">
                    <v-icon dark left> mdi-plus </v-icon>
                    Add Listing
                </div>
                <div v-else>
                    <v-icon dark left> mdi-minus </v-icon>
                    Close
                </div>
            </v-btn>
        </div>
    </div>
</template>

<script>
export default {
    name: "MarketplaceHeader",
    props: {
        isOnListing: Boolean,
        listings: Array,
        showAddListing: Boolean,
    },
    methods: {
        onClick() {
            this.$emit("btn-click");
        },
    },
};
</script>
<style lang="scss" scoped>
.container {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 20px;
    margin-top: 20px;
}
.marketplace-nav {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 20px;
}
.marketplace-nav h3 {
    transition: background-color 0.2s;
    cursor: pointer;
    padding: 5px 10px;
    border-radius: 5px;
    &:hover {
        background-color: #f9f9f9;
    }
}

.active:after {
    content: "";
    float: left;
    background: $yellow;
    width: 100%;
    height: 3px;
    border-radius: 3px;
}
</style>
